// lib/logger/console.ts
var isDevelopment = true;
var logError = (action) => (err) => {
  console.log("[ERROR]", action, ":", err);
  throw err;
};
var logResults = (action) => (results) => {
  logDebug(action, results);
  return results;
};
var logDebug = (...msg) => {
  if (isDevelopment || window.debug) {
    console.debug("[DEBUG]", (/* @__PURE__ */ new Date()).toLocaleTimeString(), ...msg);
  }
};
var logInfo = (...msg) => {
  console.log("[INFO ]", (/* @__PURE__ */ new Date()).toLocaleTimeString(), ...msg);
};

// lib/logger/logger.tsx
import { jsx } from "react/jsx-runtime";
var debugProps = (props) => /* @__PURE__ */ jsx("pre", { children: JSON.stringify(props, null, 2) });

export {
  logError,
  logResults,
  logDebug,
  logInfo,
  debugProps
};
